// extracted by mini-css-extract-plugin
export default {"container":"news_container__T8WnB","headerText":"news_headerText__BPqna","wrapper":"news_wrapper__zkeut","error":"news_error__QAunQ"};